import type { DeepPartial } from '../../default/types';
import type { OrderConfig } from '../../default/order/order.types';
import { riskIdentSnippet } from '../../default/order/order';

export const orderConfig: DeepPartial<OrderConfig> = {
  paymentMethods: ['paypal', 'mastercard', 'visa', 'diners', 'discover'],
  hasCo2Compensation: false,
  externalUrls: {
    flexikontoPaymentPause: {
      default: '/service-hilfe/bezahlung-finanzierung/flexikonto-zahlpause',
    },
  },
  premium: {
    enabled: true,
    hasRuntimeOptions: false,
    hasLegalFooter: true,
  },
  newsletterCmsPage: {
    default: 'service-hilfe/service/newsletterservice/anmelden',
    'fr-CH': 'content/service/service-newsletter/sinscrire',
  },
  paylink: {
    paymentMethods: ['mastercard', 'visa', 'diners', 'discover'],
  },
  riskIdent: {
    enabled: true,
    snippetId: riskIdentSnippet('YxcmLe'),
  },
  sovendus: {
    de: {
      trafficSourceNumber: '1561',
      trafficMediumNumber: { default: '3', mobile: '7', app: '49' },
    },
    fr: {
      trafficSourceNumber: '1567',
      trafficMediumNumber: { default: '5', mobile: '11', app: '18' },
    },
  },
};
